export const loadMore = () => {
  document.querySelectorAll('.wp-block-query').forEach((block, i) => {
    const button = block.querySelector(
      '.is-style-load-more .wp-block-query-pagination-next',
    );

    if (button) {
      button.addEventListener('click', (e) => fetchNextPage(e, block, i));
    }
  });
};

async function fetchNextPage(e, el, i) {
  e.preventDefault();
  e.stopPropagation();

  const list = el.querySelector('.wp-block-post-template');
  const { href } = e.target;
  if (!href) return;

  let items, nextPage;

  try {
    const html = await fetch(href).then((rez) => rez.text());

    let fakeDom = document.createElement('html');
    fakeDom.innerHTML = html;

    const parent = fakeDom.querySelectorAll('.wp-block-query')?.[i];

    items = parent.querySelectorAll('.wp-block-post');
    nextPage = parent.querySelector('.wp-block-query-pagination-next');
  } catch (e) {
    console.log(e);
  }

  if (items.length > 0) {
    items.forEach((item) => {
      list.appendChild(item);
    });
  }

  if (nextPage) {
    e.target.href = nextPage.href;
  } else {
    e.target.remove();
  }

  //clear out wp-container-* class from column blocks nest in query blocks
  $('.wp-block-query .wp-block-column').each(function () {
    $(this).removeClass(function (index, css) {
      return (css.match(/\bwp-container\S+/g) || []).join(' '); // removes anything that starts with "wp-container"
    });
  });
}
